import { useState, type ReactNode } from "react";

interface TabDef {
  id: string;
  label: string;
  count?: number;
  content: ReactNode;
}

interface TabsProps {
  tabs: TabDef[];
  defaultTabId?: string;
}

export default function Tabs({ tabs, defaultTabId }: TabsProps) {
  const [activeId, setActiveId] = useState(defaultTabId ?? tabs[0]?.id);
  const active = tabs.find((tab) => tab.id === activeId) ?? tabs[0];

  return (
    <div>
      <div role="tablist" className="flex gap-1 overflow-x-auto border-b border-line">
        {tabs.map((tab) => {
          const isActive = tab.id === active?.id;
          return (
            <button
              key={tab.id}
              role="tab"
              aria-selected={isActive}
              onClick={() => setActiveId(tab.id)}
              className={`shrink-0 border-b-2 px-3 py-2.5 font-mono text-xs font-semibold uppercase tracking-wide transition ${
                isActive
                  ? "border-turquoise text-ink"
                  : "border-transparent text-ink-faint hover:text-ink-dim"
              }`}
            >
              {tab.label}
              {tab.count !== undefined && (
                <span className={`ml-1.5 tabular ${isActive ? "text-turquoise" : "text-ink-faint"}`}>
                  {tab.count}
                </span>
              )}
            </button>
          );
        })}
      </div>
      <div className="pt-4">{active?.content}</div>
    </div>
  );
}
